import React from "react";

// src/components/Icons.tsx
export const OkIcon = () => <span className="status ok">&#10004;</span>;
export const NoIcon = () => <span className="status no">&#10008;</span>;
